import { InspectionLevelCode } from '@/types/InspectionLevel';
import { hasBundledTemplate } from '@/utils/inspection.utils';

export interface ConductTemplateIdentity {
  readonly tenantId: string | undefined;
  readonly controlPointName: string | undefined;
}

export interface ConductTemplateIdInput extends ConductTemplateIdentity {
  readonly templateDiscriminator: string | undefined;
  readonly inspectionLevelCode: string | undefined;
}

function toTemplateSuffix(code: string): string {
  return code.trim().toLowerCase().replace(/_/g, '-');
}

/**
 * Prefer a bundled `{tenantId}_{code-kebab}` template when present; Positive
 * Release maps to the legacy `{tenantId}_positive-release` fixtures.
 * Other inspections use the control point template discriminator.
 */
export function resolveConductTemplateId(input: ConductTemplateIdInput): string | undefined {
  const normalizedCode = (input.inspectionLevelCode ?? '').trim().toUpperCase();
  if (normalizedCode === InspectionLevelCode.POSITIVE_RELEASE) {
    return `${input.tenantId}_positive-release`;
  }
  if (normalizedCode) {
    const codeTemplateId = `${input.tenantId}_${toTemplateSuffix(normalizedCode)}`;
    if (hasBundledTemplate(codeTemplateId)) {
      return codeTemplateId;
    }
  }
  return input.templateDiscriminator;
}
